export function PotentialPayoutsIcon() {
  return (
    <svg
      width="16"
      height="13"
      viewBox="0 0 16 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2 0.626953C1.46957 0.626953 0.960859 0.839885 0.585786 1.21891C0.210714 1.59793 0 2.11199 0 2.64801V6.69013C0 7.22614 0.210714 7.74021 0.585786 8.11923C0.960859 8.49825 1.46957 8.71118 2 8.71118V2.64801H12C12 2.11199 11.7893 1.59793 11.4142 1.21891C11.0391 0.839885 10.5304 0.626953 10 0.626953H2ZM4 6.69013C4 6.15411 4.21071 5.64005 4.58579 5.26102C4.96086 4.882 5.46957 4.66907 6 4.66907H14C14.5304 4.66907 15.0391 4.882 15.4142 5.26102C15.7893 5.64005 16 6.15411 16 6.69013V10.7322C16 11.2683 15.7893 11.7823 15.4142 12.1613C15.0391 12.5404 14.5304 12.7533 14 12.7533H6C5.46957 12.7533 4.96086 12.5404 4.58579 12.1613C4.21071 11.7823 4 11.2683 4 10.7322V6.69013ZM10 10.7322C10.5304 10.7322 11.0391 10.5193 11.4142 10.1403C11.7893 9.76127 12 9.2472 12 8.71118C12 8.17517 11.7893 7.6611 11.4142 7.28208C11.0391 6.90306 10.5304 6.69013 10 6.69013C9.46957 6.69013 8.96086 6.90306 8.58579 7.28208C8.21071 7.6611 8 8.17517 8 8.71118C8 9.2472 8.21071 9.76127 8.58579 10.1403C8.96086 10.5193 9.46957 10.7322 10 10.7322Z"
        fill="white"
      />
    </svg>
  );
}
